import React from 'react';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import './main.scss';
import './fgrid.scss';

import Header from './components/header/header.jsx';
import Footer from './components/footer/footer.jsx';
const Main = (props) => {
  return (
    <div className='main-wrap'>
      <Header />
      {renderRoutes(props.route.routes)}
      <Footer />
    </div>
  );
};

export default connect()(Main);



// WEBPACK FOOTER //
// ./src/client/main.js